import { Component, OnInit, Input } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import * as $ from 'jquery';

@Component({
  selector: 'app-cq2',
  templateUrl: './cq2.component.html',
  styleUrls: ['./cq2.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq2Component implements OnInit {
  @Input() data: any;
  firstname: String;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  disablebutton = false;
  showbutton = true;
  deviceWidth;
  question_sub1;
  question_sub2;
  question_sub3;
  question_sub4;
  timer;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
   }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('needs ');
          this.question_sub1 = question_sub1[0] + ' needs';
          const question_sub2 = question_sub1[1].split('plans ');
          this.question_sub2 = question_sub2[0] + ' plans';
          const question_sub3 = question_sub2[1].split('choose. ');
          this.question_sub3 = question_sub3[0] + ' choose';
          this.question_sub4 = question_sub3[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.firstname = obj.fieldValue;
        this.disablebutton = true;
        if (this.deviceWidth < 768) {
          this.getFirstname();
        }
      }
    }

    if(!this.disablebutton)
    {
     this.showbutton = false;
    }

  }

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  enableButton(event) {
    const isWhitespace = (this.firstname || '').trim().length === 0;
      const isValid = !isWhitespace;
    if (_.isEmpty(this.firstname) && isValid === true) {
      this.disablebutton = false;
    } else if(isValid === false){
      this.disablebutton = false;
    } else {
      this.disablebutton = true;
    }
  }

  eventHandler(event) {
    if (event.which === 13){
      this.getFirstname();
    }
 }

  getFirstname() {
    if (_.isEmpty(this.firstname) && this.firstname != "") {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      const Obj = {
        'com_question_id': this.data,
        'fieldName': 'first_name',
        'fieldValue': this.titleCase(this.firstname)
      };

      const isWhitespace = (this.firstname || '').trim().length === 0;
      const isValid = !isWhitespace;
    
      if(isValid === true && this.firstname != "" && this.firstname.length > 0){
        this.disablebutton = true;
        this.commercialService.updateResponses(Obj);
        
      }else{
        this.disablebutton = false;
      }

      
      clearTimeout(this.timer);
      if (this.deviceWidth < 768) {
        this.timer = setTimeout(() => {
          this.next();
        }, 1000);
      } else {
        this.next();
      }
    }
  }

  next() {
    if(this.disablebutton === true){
      this.commercialService.messageService({ 'currentId': this.data });
    }
    
  }

}
